import React, { useContext, useEffect, useState } from 'react';
import Toggle from './Toggle';
import MARInput from './MARInput';
import { useMediaQuery } from 'react-responsive';
import appContext from '../AppContext';
import { filterSortSchools } from '../services/WranglingService';
import { useTranslation } from "react-i18next";
import appConfig from '../config/appConfig.json';

const k12 = Array.from({length: 12}, (_, i) => i + 1);
const gradeLabels = ['PK3', 'PK4', 'K'].concat(k12);
const initGrades = gradeLabels.map((item)=>{ return {label: item, value: false}});
const wardLabels = Array.from({length: 8}, (_, i) => i + 1);
const initWards = wardLabels.map((item)=> { return {label: item, value: false}});
const offeringLabels = appConfig.offerings;
const initOfferings = offeringLabels.map((item)=> { return {...item, value: false}});

function Filter() {
    const [grades, setGrades] = useState(initGrades);
    const [wards, setWards] = useState(initWards);
    const [offerings, setOfferings] = useState(initOfferings);
    const [inBoundaryOnly, setInBoundaryOnly] = useState(false);
    const isMobile = useMediaQuery({ query: `(max-width: 767px)` });
    const {filterInit, originSchools, setSchools, setGradeFilters, setWardFilters, setOfferingSorts, searchedPlace, inBoundaryFilter, setInBoundaryFilter, locale} = useContext(appContext);
    const { t } = useTranslation();

    useEffect(() => {
        // only set once app has been loaded and original schools set
        if (window.location.search !== "" && filterInit && originSchools.length > 0) {
            // get parameters from URL query - and set UI in filter
            // (actual filters should be set in app.js on load)
            const params = new URL(window.location).searchParams;
            const paramGrades = params.get('selGrades');
            const paramWards = params.get('selWards');
            const paramOfferings = params.get('programs');
            if (paramGrades) {
                let gradeArray = paramGrades.split(",");
                let selectedGrades = grades.map(item => {
                    item.value = gradeArray.includes(item.label.toString().toLowerCase().replace(/pk3/g,'pk_3').replace(/pk4/g, 'pk_4'));
                    return item;
                });
                setGrades(selectedGrades);
            }
            if (paramWards) {
                let wardArray = paramWards.split(",");
                let selectedWards = wards.map(item => {
                    item.value = wardArray.includes(item.label.toString());
                    return item;
                });
                setWards(selectedWards);
            }
            if (paramOfferings) {
                let offeringArray = paramOfferings.split(",");
                let selectedOfferings = offerings.map(item => {
                    item.value = offeringArray.includes(item.id.toString());
                    return item;
                });
                // if 9999 in programs - that means set in boundary to true
                if (offeringArray.includes("9999") && searchedPlace) {
                    setInBoundaryOnly(true);
                }
                setOfferings(selectedOfferings);
            }
          }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterInit, originSchools]);


    useEffect(() => {
        setInBoundaryOnly(inBoundaryFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inBoundaryFilter]);

    const gradeClickHandler = (i) => {
        let items = [...grades];
        let item = items[i];
        item.value = !item.value;
        setGrades(items);

        let gradeSelected = items.filter((x)=>x.value === true);
        let gradeFilters = gradeSelected.map(x=>x.label.toString().toLowerCase().replace(/pk3/g,'pk_3').replace(/pk4/g, 'pk_4'));

        //update context
        setGradeFilters(gradeFilters);
        setFiltersAndSchools(gradeFilters, null, null, null);
    }

    const wardClickHandler = (i) => {
        let items = [...wards];
        let item = items[i];
        item.value = !item.value;
        setWards(items);

        let wardSelected = items.filter((x)=>x.value === true);
        let wardFilters = wardSelected.map(x=>x.label.toString());
        //update context
        setWardFilters(wardFilters)
        // set schools based on filters
        setFiltersAndSchools(null, wardFilters, null, null);
    }    

    const offeringClickHandler = (evt, i) => {
        evt.preventDefault();
        let items = [...offerings];
        // if value - update that value - else clear all filters
        if (i !== null) {
            let item = items[i];
            item.value = !item.value;
        } else {
            items = items.map(item => {
                item.value = false;
                return item;
            });
        }

        setOfferings(items);

        let offeringsSelected = items.filter((x)=> x.value === true);
        //update context
        setOfferingSorts(offeringsSelected); 
        // set schools based on filters
        setFiltersAndSchools(null, null, offeringsSelected, null);
    }    

    const inBoundaryOnlyClickHandler = (evt) => {
        evt.preventDefault();
        // if address present - and inboundary toggle changed
        if (searchedPlace) {
            let inBoundaryOnlyFilter = !inBoundaryOnly
            setInBoundaryOnly(inBoundaryOnlyFilter);
            // update context
            setInBoundaryFilter(inBoundaryOnlyFilter);
            // set schools based on filters
            setFiltersAndSchools(null, null, null, inBoundaryOnlyFilter);
        }
    }

    const setFiltersAndSchools = (inGrades, inWards, inOfferings, inInBounds) => {
        // consolidate setting filters and setting schools after performing above
        let gradeFilters = inGrades || grades.filter((x)=>x.value === true).map(x=>x.label.toString().toLowerCase().replace(/pk3/g,'pk_3').replace(/pk4/g, 'pk_4'));
        let wardFilters = inWards || wards.filter((x)=>x.value === true).map(x=>x.label.toString());
        let offeringSorts = inOfferings || offerings.filter((x)=> x.value === true);
        let inBoundarySort = (inInBounds != null) ? inInBounds : inBoundaryOnly;

        let schoolsTemp = filterSortSchools(originSchools, gradeFilters, wardFilters, offeringSorts, inBoundarySort);
        setSchools(schoolsTemp); 
    }

    return (
        <div className={ "flex flex-col px-3 py-2 print:hidden" + (isMobile ? " absolute inset-0 overflow-scroll z-[5000] bg-my-gray sm:container sm:border border-gray-600 mx-auto" : " w-full") }>
            {
                (!isMobile) ? <>
                    <p className="text-my-emerald text-[12px] leading-[16px] font-extrabold mt-2 w-full">{t('filter.title')}</p>
                    <div className="block p-[6px] shadow-lg bg-white mt-[10px]">
                        <div className="w-[30px] h-[30px] bg-my-emerald rounded-br-[30px] mt-[-6px] ml-[-6px] float-left mr-2">
                            <img className="w-[14px] mt-[5px] ml-[5px]" src="./icons/Star_Icon.png" alt="Enter Address To Center Map"></img>
                        </div>
                        <p className="text-my-emerald text-[12px] leading-tight font-extrabold mb-2">{t('filter.address.title')}</p>
                        <MARInput></MARInput>
                    </div></>
                :
                    <><p className="text-my-emerald text-[12px] leading-[16px] font-extrabold mt-2 w-full">{t('filter.address.title')}</p></>
            }

            <div className="block p-[6px] shadow-lg bg-white  mt-[10px]">
                <div className={"w-[30px] h-[30px] bg-my-emerald rounded-br-[30px] mt-[-6px] ml-[-6px] float-left mr-2 " + (searchedPlace? "bg-my-emerald" :"bg-[#C0C0C0]")}>
                    <img className="w-[14px] mt-[7px] ml-[5px]" src="./icons/Boundary_Icon.png" alt="Find In-Boundary School"></img>
                </div>
                <p className={"text-[12px] leading-tight font-extrabold mb-[14px] " + (searchedPlace? "text-my-emerald" :"text-[#C0C0C0]")}>{t('filter.boundary.title')}</p>
                <p className="text-[10px] leading-[14px] tracking-[0px] mb-2 font-[400] text-[#333333] mx-1">{t('filter.boundary.enterhome')}</p>
                <div onClick={(evt)=> inBoundaryOnlyClickHandler(evt)}>
                    <Toggle label={t("filter.boundary.inboundaryonly")} checked={inBoundaryOnly} disabled={!searchedPlace} />
                </div>
                <p className="text-[10px] leading-[14px] tracking-[0px] mb-2 font-[400] text-[#333333] mx-1">{t('filter.boundary.requireapplication')}</p>
            </div>

            <div className="block p-[6px] shadow-lg bg-white mt-[10px]">
                <div className="w-[30px] h-[30px] bg-my-emerald rounded-br-[30px] mt-[-6px] ml-[-6px] float-left mr-2">
                    <img className="w-[14px] mt-[7px] ml-[5px]" src="./icons/School_Icon.png" alt="Filter by grade"></img>
                </div>
                <div className="text-my-emerald text-[12px] leading-tight font-extrabold mb-[14px]">{t('filter.grade.title')}</div>
                <div className="grid grid-cols-6 grid-flow-row gap-1 mx-1 mb-2">
                    {
                        grades.map((item, i) => {
                                return (
                                    <div key={i} value={item.label} onClick={()=> gradeClickHandler(i)}
                                    className={
                                        `text-center text-[10px] cursor-pointer 
                                        ${grades[i].value ? 'bg-[#618c95] border-my-emerald border-b-[2px]': ' bg-[#F3F3F3] border-b-[#F3F3F3] border-b-[2px]'}
                                        `
                                    }>
                                        {item.label}
                                    </div>
                                );
                            })
                    }
                </div>
            </div>

            <div className="block p-[6px] shadow-lg bg-white mt-[10px]">
                <div className="w-[30px] h-[30px] bg-my-emerald rounded-br-[30px] mt-[-6px] ml-[-6px] float-left mr-2">
                    <img className="w-[14px] mt-[7px] ml-[5px]" src="./icons/School_Icon.png" alt="Filter by ward"></img>
                </div>
                <p className="text-my-emerald text-[12px] leading-tight font-extrabold mb-[14px]">{t('filter.ward.title')}</p>
                <div className="grid grid-cols-6 grid-flow-row gap-1 mx-1 mb-2">
                    {
                        wards.map((item, i) => {
                                return (
                                    <div key={i} value={item.value} onClick={()=> wardClickHandler(i)}
                                    className={
                                        `text-center text-[10px] cursor-pointer 
                                        ${wards[i].value ? 'bg-white border-my-emerald border-b-[2px]': ' bg-[#F3F3F3] border-b-[#F3F3F3] border-b-[2px]'}
                                        `
                                    }>
                                        {item.label}
                                    </div>
                                );
                            })
                    }
                </div>
            </div>

            <div className="block p-[6px] shadow-lg bg-white mt-[10px]">
                <div className="w-[30px] h-[30px] bg-my-emerald rounded-br-[30px] mt-[-6px] ml-[-6px] float-left mr-2">
                    <img className="w-[14px] mt-[7px] ml-[5px]" src="./icons/Apple_Icon.png" alt="Sort by Offering"></img>
                </div>
                <p className="text-my-emerald text-[12px] leading-tight font-extrabold mb-[7px]">{t('filter.offering.title')}</p>
                <span className='flex justify-end'>
                    <p className="mr-1 text-my-emerald underline text-xs mb-1 cursor-pointer" onClick={(evt)=> offeringClickHandler(evt, null)}>{t('filter.offering.clear')}</p>
                </span>
                {
                    offerings.map((item, i) => {
                        return (
                            <div key={i} onClick={(evt)=> offeringClickHandler(evt, i)}>
                                <Toggle label={(locale === 'es')? item.es : item.label} checked={item.value} />
                            </div>
                        );
                    })
                }
            </div>

        </div>
    );
}

export default Filter;
